import { SpriteSvg } from '../../toolbars/ObjectMenu/SpriteSvg';
import PlaceholderImageCache from './placeholderImageCache';

// Statically caches the loading of images so they can be reused across
// multiple renders and objects.
export default class ImageCache {
  // Cache of prepared images keyed by sprite id.
  static images: Record<string, HTMLImageElement> = {};

  image?: HTMLImageElement;

  constructor(
    private readonly iconName: string,
    private readonly width: number,
    private readonly height: number,
    private readonly readyCallback: () => void
  ) {
    this.iconName = iconName;
    this.width = width;
    this.height = height;
    this.readyCallback = readyCallback;

    this.prepareImage();
    PlaceholderImageCache.preparePlaceholder();
  }

  get placeholderImage() {
    return PlaceholderImageCache.placeholderImage;
  }

  renderPlaceholder(
    ctx: CanvasRenderingContext2D,
    obj: { width: number; height: number }
  ) {
    PlaceholderImageCache.renderPlaceholder(ctx, obj);
  }

  prepareImage() {
    const cacheKey = `${this.iconName}-${this.width}`;
    const cachedImage = ImageCache.images[cacheKey];

    if (cachedImage) {
      this.image = cachedImage;
      this.readyCallback();
      return;
    }

    const svgString = this.getSvgString();

    if (svgString) {
      const newImage = new Image();
      newImage.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
        svgString
      )}`;
      newImage
        .decode()
        .then(this.readyCallback)
        .catch(encodingError => {
          console.error('Error decoding image', encodingError);
        });
      ImageCache.images[cacheKey] = newImage;
      this.image = newImage;
    }
  }

  private getSvgString() {
    const svgString = SpriteSvg.getInstance().svgStringForIcon(this.iconName);
    if (svgString) {
      // Adjust the height of the svg to fit the shape.
      return svgString
        .replace(/width="[^"]*"/, `width="${this.width}"`)
        .replace(/height="[^"]*"/, `height="${this.height}"`);
    }
  }
}
